import EditPage from '../views/EditPage';

const router = [
  {
    name: 'editPage',
    path: '/pages/:page_id/edit',
    component: EditPage,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/edit-page/router/index.js